import { CssBaseline } from "@mui/material"
import { ThemeProvider, createTheme, StyledEngineProvider } from "@mui/material/styles"
//
import { GlobalStyles } from "./global-styles"
import shape from "./shape"
import palette from "./palette"
import typography from "./typography"
import shadows from "./shadows"
import componentsOverride from "./overrides"

export const ThemeConfig = ({ children }) => {
  const theme = createTheme({
    GlobalStyles,
    palette,
    shape,
    shadows,
    typography,
  })
  theme.components = componentsOverride(theme)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
